import { createContext } from "react";

/**
 * SessionContext exposes the imperative actions SessionProvider wires up
 * to the rest of the app — primarily the 401 interceptor in api/axios.js.
 *
 * The Context value shape:
 *   {
 *     refreshToken: () => Promise<string>   // resolves with the new token
 *     performLogout: () => void             // single-flight logout
 *     isSilentRefreshRoute: (path) => bool  // route-based silent-refresh check
 *   }
 */
export const SessionContext = createContext(null);